export default [
  {
    fieldName: 'Firstname',
    isRequired: true,
    label: 'Jméno',
    type: 'text'
  },
  {
    fieldName: 'Lastname',
    isRequired: true,
    label: 'Příjmení',
    type: 'text'
  },
  {
    fieldName: 'Email',
    isRequired: true,
    label: 'E-mail',
    type: 'email'
  },
  {
    fieldName: 'Phone',
    isRequired: true,
    label: 'Telefon',
    type: 'text'
  },
  {
    fieldName: 'Address',
    type: 'address',
    isRequired: true
  },
  {
    fieldName: 'differentAddress',
    type: 'hidden',
    label: 'Zboží chci doručit na jinou adresu.',
    fields: [
      {
        fieldName: 'AddressSecondary',
        type: 'address'
      }
    ]
  },
  {
    fieldName: 'companyInfo',
    type: 'hidden',
    label: 'Zadat firemní údaje',
    fields: [
      {
        fieldName: 'Company',
        label: 'Název firmy',
        type: 'text'
      },
      {
        fieldName: 'CompanyRegistrationNumber',
        label: 'IČ',
        type: 'text'
      },
      {
        fieldName: 'CompanyVatNumber',
        label: 'DIČ',
        type: 'text'
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/formFields/delivery.tsx